import request from "../helpers/request";
import {createRestfulApi} from "./createRestfulApi";

const URL = {
    // 部门列表
    GETBUMENLIST: "assist/getAssistDepartList",
    MOVE_ASSIST_DEPART: "assist/moveAssistDepart",
    SAVEBUMEN: "assist/saveAssistDepart",
    DELETEBUMEN: "assist/deleteAssistDepart",
    //   类别列表
    GETLEIBIELIST: "assist/getAssistClassList",
    MOVE_ASSIST_CLASS: "assist/moveAssistClass",
    SAVELEIBIE: "assist/saveAssistClass",
    DELETELEIBIE: "assist/deleteAssistClass",
    // 角色列表
    GETROLELIST: "assist/getAssistRoleList",
    MOVE_ASSIST_ROLE: "assist/moveAssistRole",
    SAVEROLE: "assist/saveAssistRole",
    DELETEROLE: "assist/deleteAssistRole",
    DEPLOY_ASSIST_ROLE: "assist/deployAssistRole",
    READDOCUMENT: "wiki/readDocument",
    // 工单
    GET_ASSIST_WORK_ORDER: "assist/getAssistWorkOrder",
    HANDLE_ASSIST_WORK_ORDER: "assist/handleAssistWorkOrder",
    // 问答
    GET_DOC_SUBJECT_LIST: "assist/getDocSubjectList",
    // 咨询
    GET_USER_CHAT_LOG_OVERVIEW: "/client/openai/getUserChatLogOverview",
    GET_CHAT_LOG: "/client/openai/getUserChatLog",
    ANSWER_CONSULTING: "/client/openai/answerConsulting",
};

export default {
    answerConsulting({userId, content}) {
        return request(URL.ANSWER_CONSULTING, "POST", {userId, content})
    },
    getChatLog({userId, beforeTime, afterTime, page, size}) {
        return request(URL.GET_CHAT_LOG, "POST", {userId, beforeTime, afterTime, page, size})
    },
    // 获取用户消息列表
    getUserChatLogOverview({page, size}) {
        return request(URL.GET_USER_CHAT_LOG_OVERVIEW, "POST", {page, size})
    },
    // 获取所有文档主题
    getDocSubjectList() {
        return request(URL.GET_DOC_SUBJECT_LIST, "GET")
    },
    // 部门列表
    getBuMenList: createRestfulApi(URL.GETBUMENLIST, {
        queryParams: [],
    }),
    // 移动部门
    moveAssistDepart(params) {
        return request(URL.MOVE_ASSIST_DEPART, "POST", params)
    },
    // 新增编辑部门
    saveBuMen({id, assistClassId, name}) {
        return request(URL.SAVEBUMEN, "POST", {id, assistClassId, name});
    },
    // 删除部门
    deleteBuMen({id}) {
        return request(URL.DELETEBUMEN, "POST", {id});
    },
    // 类别列表
    getLeiBieList: createRestfulApi(URL.GETLEIBIELIST, {
        queryParams: [],
    }),
    // 移动类别
    moveLeiBie(params) {
        return request(URL.MOVE_ASSIST_CLASS, "POST", params)
    },
    // 添加编辑类别
    saveLeiBie(payload) {
        return request(URL.SAVELEIBIE, "POST", payload);
    },
    // 删除类别
    deleteLeiBie({id}) {
        return request(URL.DELETELEIBIE, "POST", {id});
    },
    // 角色列表
    getRoleList: createRestfulApi(URL.GETROLELIST, {
        queryParams: [],
    }),
    // 移动角色
    moveAssistRole(params) {
        return request(URL.MOVE_ASSIST_ROLE, "POST", params)
    },
    saveRole({id, name, assistDepartId, assistRoleMaterial}) {
        return request(URL.SAVEROLE, "POST", {
            id,
            name,
            assistDepartId,
            assistRoleMaterial,
        });
    },
    deleteRole({id}) {
        return request(URL.DELETEROLE, "POST", {
            id,
        });
    },
    deployAssistRole(payload) {
        return request(URL.DEPLOY_ASSIST_ROLE, "POST", payload);
    },
    readDocument(payload) {
        return request(URL.READDOCUMENT, "POST", payload, false, true);
    },
    // 工单列表
    getAssistWorkOrder: createRestfulApi(URL.GET_ASSIST_WORK_ORDER, {
        queryParams: [],
    }),
    // 禁用工单
    handleAssistWorkOrder({id}) {
        return request(URL.HANDLE_ASSIST_WORK_ORDER, "POST", {id});
    },
};
